module.exports = __webpack_public_path__ + "img/default_unauthorized.021e479d.png";